import Vue from "vue";
import * as dayjs from "dayjs";
import "dayjs/locale/ja";

dayjs.locale("ja");

// 配列をカンマ区切りのテキストにする
function arrayJoin(array, sep = "、") {
  if (!array || !array.length) {
    return;
  }
  return array.join(sep);
}

// 日付の表示形式を変更する
function dateText(string, format) {
  if (!string) {
    return "";
  }
  if (!format) {
    return dayjs(string)
      .toISOString()
      .replace(/\.[0-9]+/, "");
  }
  return dayjs(string).format(format);
}

// 数字を3桁ずつカンマ区切りにする
function separateNumber(number) {
  if (number === null) {
    return number;
  }
  return String(number).replace(/^(-?\d+)(?=\.|$)/, (s) => {
    return s.replace(/(\d+?)(?=(?:\d{3})+$)/g, "$1,");
  });
}

// 数字を任意の桁数にする
function zeroPadding(number, digit) {
  digit = digit || 2;
  if (digit >= 2) {
    return (Array(digit).join("0") + number).slice(-digit);
  }
  return number;
}

// 文字列を任意の文字数で短縮する
function truncateText(str, len) {
  let result = 0;
  let text = "";
  for (let i = 0; i < str.length; i++) {
    const chr = str.charCodeAt(i);
    if (
      (chr >= 0x00 && chr < 0x81) ||
      chr === 0xf8f0 ||
      (chr >= 0xff61 && chr < 0xffa0) ||
      (chr >= 0xf8f1 && chr < 0xf8f4)
    ) {
      result += 1;
    } else {
      result += 2;
    }
    if (result <= len) {
      text += str[i];
    } else {
      text += "...";
      break;
    }
  }
  return text;
}

Vue.filter("arrayJoin", arrayJoin);
Vue.filter("dateText", dateText);
Vue.filter("separateNumber", separateNumber);
Vue.filter("zeroPadding", zeroPadding);
Vue.filter("truncateText", truncateText);
